module.exports = __webpack_public_path__ + "img/cleveland_clinic.b21c061c.svg";